import React from 'react';
import Icon from '../../icons/Icon';
import styles from './Slot.module.scss';

const Slot = (props) => {
    const { selected, slot, onClick, formatTime, locationRequired } = props,
        classes = [styles.Slot];

    let icon;

    if (selected) {
        classes.push(styles.selected);
    }

    // console.log('slot', slot.start_local, slot.location_ids)

    // logic copied from /xamarin/netwerkapp/netwerkapp/ViewModels/MeetingSlotGridViewModel.cs#L160
    if (slot.self_blocked > 0) {
        classes.push(styles.statusSelfBlocked);
        icon = <Icon src="img/clear_icon.png" color="white" size={18} />;
    } else if (slot.mendatory_session) {
        classes.push(styles.statusMandatorySession);
        icon = <Icon src="img/eventschedules.png" color="white" size={18} />;
    } else if (slot.self_busy > 0) {
        if (slot.type == 'speeddate') {
            classes.push(styles.statusSelfBusySpeedDate);
            icon = <Icon src="img/speeddate_icon.png" color="white" size={18} />;
        } else if (slot.type == 'meeting') {
            classes.push(styles.statusSelfBusyMeeting);
            icon = <Icon src="img/eventmeeting.png" color="white" size={18} />;
        } else {
            classes.push(styles.statusSelfBusy);
            icon = <Icon src="img/eventschedules.png" color="white" size={18} />;
        }
    } else if (!slot.self_available) {
        if (slot.type == 'speeddate') {
            classes.push(styles.statusSelfTakenSpeeddate);
            icon = <Icon src="img/speeddate_icon.png" color="white" size={18} />;
        } else {
            classes.push(styles.statusSelfTaken);
            icon = <Icon src="img/eventmeeting.png" color="white" size={18} />;
        }
    } else if (slot.others_available == 0) {
        classes.push(styles.statusUnavailable);
    } else if (locationRequired && !slot.location_ids.length) {
        classes.push(styles.statusNoMeetingPoint);
    } else if (slot.others_busy > 0) {
        classes.push(styles.statusOtherBusy);
    } else if (slot.type == 'speeddate') {
        icon = <Icon src="img/speeddate_icon.png" color="white" size={18} />;
        classes.push(styles.statusSpeeddateAvailable);
    } else {
        classes.push(styles.statusAvailable);
    }

    return (
        <div className={classes.join(' ')} onClick={onClick}>
            {formatTime(slot.start_local)}
            {icon}
        </div>
    );
};

export default Slot;
